const CATEGORY_SPACES = 8;

const DESCRIPTION_SPACES = 6;

export const FORMAT_SPACES = {
  category: CATEGORY_SPACES,
  description: DESCRIPTION_SPACES,
};
